import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider, PLACEMENT } from 'baseui/snackbar';
import { BaseProvider, LightTheme, useStyletron } from 'baseui';
import { Provider as StyletronProvider } from 'styletron-react';
import { Client as Styletron } from 'styletron-engine-atomic';

import {
	AppProvider,
	UserProvider,
	AjaxProvider,
	EffectProvider,
	GLOBAL_THEME,
	DrawerProvider,
	ModalProvider,
	DASHBOARD,
	MerchantContext,
	MerchantProvider
} from 'commons-ui';

import { UserDetailsProvider } from 'context/userDetails';
import config from 'config';
import Routes from '../pages/Routes';

const engine = new Styletron();

const PrimaryLayout: React.FC<{}> = () => {
	const [css] = useStyletron();
	return (
		<BaseProvider theme={LightTheme}>
			<MerchantProvider>
				<SnackbarProvider placement={PLACEMENT.bottom}>
					<EffectProvider>
						<AjaxProvider baseURL={config.API_URL} adminBaseUrl={config.ADMIN_API_URL}>
							<UserProvider>
								<AppProvider dashboard={DASHBOARD.CRM} MerchantContext={MerchantContext}>
									<UserDetailsProvider>
										<DrawerProvider>
											<ModalProvider>
												<div
													className={css({
														position: 'fixed',
														overflow: 'hidden',
														top: 0,
														bottom: 0,
														left: 0,
														right: 0,
														backgroundColor: GLOBAL_THEME.Colors.lightGrey
													})}>
													<Routes />
												</div>
											</ModalProvider>
										</DrawerProvider>
									</UserDetailsProvider>
								</AppProvider>
							</UserProvider>
						</AjaxProvider>
					</EffectProvider>
				</SnackbarProvider>
			</MerchantProvider>
		</BaseProvider>
	);
};

const App = () => {
	return (
		<StyletronProvider value={engine}>
			<BrowserRouter>
				<PrimaryLayout />
			</BrowserRouter>
		</StyletronProvider>
	);
};
export default App;
